var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupSnsLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_col"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M111.651 32.7797C103.884 29.1453 95.5779 26.504 86.8945 25C85.8281 26.9281 84.5822 29.5213 83.7232 31.5843C74.4925 30.1961 65.3467 30.1961 56.2858 31.5843C55.427 29.5213 54.1528 26.9281 53.0768 25C44.384 26.504 36.0688 29.155 28.301 32.7989C12.6332 56.4749 8.38594 79.5629 10.5096 102.323C20.9013 110.083 30.972 114.797 40.8729 117.882C43.3174 114.518 45.4977 110.941 47.3759 107.172C43.7988 105.813 40.3726 104.135 37.1354 102.188C37.9942 101.552 38.8343 100.887 39.6459 100.202C59.391 109.437 80.8445 109.437 100.354 100.202C101.175 100.887 102.015 101.552 102.864 102.188C99.6174 104.145 96.1819 105.822 92.6048 107.182C94.483 110.941 96.6538 114.527 99.1078 117.892C109.018 114.807 119.098 110.093 129.49 102.323C131.982 75.9382 125.233 53.0623 111.651 32.7797ZM50.0659 88.3257C44.1386 88.3257 39.2778 82.7923 39.2778 76.0539C39.2778 69.3155 44.0348 63.7724 50.0659 63.7724C56.0971 63.7724 60.9578 69.3058 60.854 76.0539C60.8634 82.7923 56.0971 88.3257 50.0659 88.3257ZM89.9337 88.3257C84.0064 88.3257 79.1456 82.7923 79.1456 76.0539C79.1456 69.3155 83.9025 63.7724 89.9337 63.7724C95.9648 63.7724 100.826 69.3058 100.722 76.0539C100.722 82.7923 95.9648 88.3257 89.9337 88.3257Z",
    fill: "#5865F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupSnsLogo1);
export default __webpack_public_path__ + "static/media/sup_sns_logo1.c8660e9ebfb0ac54fa48177baaae19a7.svg";
export { ForwardRef as ReactComponent };